<template>
    <div class="footer">
      <!-- Floating Chat Button -->
      <div class="chat-button" @click="openChat"> 💬 Chat </div>
  
      <!-- Chat Box -->
      <div v-if="showChat" class="chat-box">
        <div class="chat-header rounded">
          <span>Chat Bot</span>
          <button class="btn btn-primary" @click="closeChat">✖</button>
        </div>
  
          <!-- Chat messages area -->
          <div ref="chatContainer" class="flex-grow-1 overflow-auto rounded shadow p-3 " style="min-height: 300px; max-height: 300px; overflow-y: auto;">
            <div v-for="(message, index) in chatMessages" :key="index" class="d-flex mb-3" :class="{'justify-content-end': message.role === 'user'}">
              
              <!-- Bot Message with Profile -->
              <div v-if="message.role === 'assistant' || message.role === 'loading'" class="d-flex align-items-center  w-75">
                <img src="/assets/images/Explore2Teach_Logo.png" alt="Bot" class="rounded-circle me-2" width="40" height="40">
                <div class="p-2 rounded bot_bg text-white text-left">
                  {{ message.content }}
                </div>
              </div>

              <!-- User Message with Profile -->
              <div v-else class="d-flex align-items-center w-75 justify-content-end">
                <div class="p-2 rounded  user_bg text-white">
                  {{ message.content }}
                </div>
                <!-- <img src="/assets/images/Explore2Teach_Logo.png" alt="User" class="rounded-circle ms-2" width="40" height="40"> -->
              </div>
              
            </div>
          </div>

        <!-- Input area -->
        <div class="d-flex">
            <input 
              v-model="localSearchQuery"
              type="text" 
              class="form-control rounded" 
              placeholder="Type your message..."
              @keyup.enter="handleSendMessage"
            >
            <button class="btn btn-primary rounded" @click="handleSendMessage">Send</button>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapMutations, mapActions } from "vuex";
  
  export default {
    data() {
      return {
        localSearchQuery: "", // Use a local variable instead of modifying Vuex state directly
      };
    },
    computed: {
      ...mapState(["showChat", "chatMessages"]),
    },
    watch: {
        chatMessages: {
            handler() {
            this.$nextTick(() => {
                this.scrollToBottom();
            });
            },
            deep: true, // Ensure Vue detects nested changes
            immediate: true, // Scroll when component mounts
        },
    },
    methods: {
      ...mapMutations(["SET_SEARCH_QUERY"]), // Mutation to update Vuex state
      ...mapActions(["openChat", "closeChat", "sendMessage"]),
      
      async handleSendMessage() {
        if (!this.localSearchQuery.trim()) return;
  
        const userMessage = this.localSearchQuery;
        this.localSearchQuery = ""; // Clear input field locally
  
        // Update Vuex state for searchQuery
        this.SET_SEARCH_QUERY(userMessage);
  
        // Send message via Vuex action
        await this.sendMessage();
      },
      
      scrollToBottom() {
        this.$nextTick(() => {
            if (this.$refs.chatContainer) {
            this.$refs.chatContainer.scrollTop = this.$refs.chatContainer.scrollHeight;
            }
        });
        }

    },
  };
  </script>
  
  
  <style scoped>
  .footer {
    padding: 10px;
    background: #f1f1f1;
  }
  
  /* Floating Chat Button */
  .chat-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #007bff;
    color: white;
    padding: 12px 18px;
    font-size: 16px;
    border-radius: 50px;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease-in-out;
  }
  
  .chat-button:hover {
    background: #0056b3;
  }
  
  /* Chat Box */
  .chat-box {
    position: fixed;
    bottom: 80px;
    right: 10px;
    width: 380px;
    background: white;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  /* Chat Header */
  .chat-header {
    background: #007bff;
    color: white;
    padding: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  
  /* Chat Content */
  .chat-content {
    flex-grow: 1;
    padding: 12px;
    min-height: 250px;
    max-height: 300px;
    overflow-y: auto;
    background: #f9f9f9;
    scrollbar-width: thin;
    scrollbar-color: #ddd #f9f9f9;
  }
  
  .chat-content::-webkit-scrollbar {
    width: 6px;
  }
  
  .chat-content::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
  }
  
  /* Message Container */
  .message-container {
    display: flex;
    margin-bottom: 10px;
    align-items: flex-end;
  }
  
  /* Bot Message */
  .bot .text {
    background: #e0e0e0;
    color: #333;
    padding: 10px 12px;
    border-radius: 12px;
    max-width: 70%;
  }
  
  /* User Message */
  .user .text {
    background: #007bff;
    color: white;
    padding: 10px 12px;
    border-radius: 12px;
    max-width: 70%;
    text-align: right;
  }
  
  /* Avatar */
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  /* Input Area */
  .chat-input {
    display: flex;
    align-items: center;
    padding: 10px;
    border-top: 1px solid #ddd;
    background: white;
  }
  
  .chat-input input {
    flex: 1;
    padding: 10px;
    border-radius: 6px;
    border: 1px solid #ccc;
    outline: none;
    font-size: 14px;
  }
  
  .chat-input button {
    margin-left: 8px;
    background: #007bff;
    color: white;
    padding: 10px 14px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: bold;
    transition: all 0.3s ease;
  }
  
  .chat-input button:hover {
    background: #0056b3;
  }
  .bot_bg {
  background-color: #30303065;
}
.user_bg {
  background-color: #1371ff;
}
  </style>
  